import { gql, useApolloClient } from "@apollo/client";
import { StackApiContext, useSnackbarApi } from "@comet/admin";
import Snackbar from "@src/components/snackbar/Snackbar";
import { type GQLDeleteCodeAdminMutation, type GQLDeleteCodeAdminMutationVariables } from "@src/graphql.generated";
import { type ReactElement, useContext } from "react";
import { useIntl } from "react-intl";

import { type CommonDeleteDialogProps, DeleteDialog } from "./DeleteDialog";

const deleteCodeAdminMutation = gql`
    mutation DeleteCodeAdmin($id: ID!) {
        removeLicence(id: $id)
    }
`;

interface DeleteCodeDialog extends CommonDeleteDialogProps {
    licenceId: string;
}

const DeleteCodeDialog = ({ licenceId, ...restProps }: DeleteCodeDialog): ReactElement => {
    const client = useApolloClient();
    const stackApi = useContext(StackApiContext);
    const intl = useIntl();
    const snackbarApi = useSnackbarApi();

    const submit = async () => {
        await client.mutate<GQLDeleteCodeAdminMutation, GQLDeleteCodeAdminMutationVariables>({
            mutation: deleteCodeAdminMutation,
            variables: { id: licenceId },
            refetchQueries: ["CodesListAdmin"],
        });
        stackApi?.goBack();

        snackbarApi.showSnackbar(
            <Snackbar
                variant="success"
                message={intl.formatMessage({
                    id: "reviermanager.licence.delete",
                    defaultMessage: "Code wurde gelöscht",
                })}
                key="reviermanager.licence.delete"
                handleClose={snackbarApi.hideSnackbar}
            />,
        );
    };

    return <DeleteDialog {...restProps} submit={submit} />;
};

export default DeleteCodeDialog;
